import { formValueSelector } from "redux-form/immutable";

import {
  HELI_REPORT_FORM,
  WORK_SCHEDULE_REPORT_FORM,
} from "features/planner/report/report.constants";

import { createSelector } from "utils/app.util";

const getPOBReportSelector = state => state.getIn(["report", "pob"]);

const getHeliReportSelector = state => state.getIn(["report", "heli"]);

const getPOBReportGroupSelector = (state, groupId) =>
  state.getIn(["report", "pob", groupId.toString()]);

const getHeliReportGroupSelector = (state, groupId) =>
  state.getIn(["report", "heli", groupId.toString()]);

export const getPOBReportFromState = createSelector(getPOBReportSelector, pob =>
  pob.toList(),
);

export const getPOBReportGroupFromState = createSelector(
  getPOBReportGroupSelector,
  pobGroup => pobGroup,
);

export const getHeliReportsFromState = createSelector(
  getHeliReportSelector,
  heli => heli,
);

export const getHeliReportGroupFromState = createSelector(
  getHeliReportGroupSelector,
  heliGroup => heliGroup,
);

const getWorkScheduleReportSelector = state =>
  state.getIn(["report", "workSchedule"]);

export const getWorkScheduleReportFromState = createSelector(
  getWorkScheduleReportSelector,
  report => report,
);

export const editHeliReportFormSelector = formValueSelector(
  HELI_REPORT_FORM.ID,
);

export const workScheduleReportSelector = formValueSelector(
  WORK_SCHEDULE_REPORT_FORM.ID,
);

const getOverridesOfScheduleOverridesReportSelector = state =>
  state.getIn(["report", "scheduleOverridesReport", "scheduleOverrides"]);

export const getOverridesOfScheduleOverridesReportFromState = createSelector(
  getOverridesOfScheduleOverridesReportSelector,
  scheduleOverrides => scheduleOverrides.toList(),
);

const getEmployeesOfScheduleOverridesReportSelector = state =>
  state.getIn(["report", "scheduleOverridesReport", "employees"]);

export const getEmployeesOfScheduleOverridesReportFromState = createSelector(
  getEmployeesOfScheduleOverridesReportSelector,
  employees => employees,
);

export const getDashboardStatsFromState = createSelector(
  state => state.getIn(["dashboard", "stats"]),
  stats => stats,
);

export const getWorkScheduleOverrideStatsFromState = createSelector(
  state => state.getIn(["dashboard", "workScheduleOverride"]),
  data => data,
);

export const getDashboardModalEmployeesFromState = createSelector(
  state => state.getIn(["dashboard", "modalEmployees"]),
  employees => employees,
);
